import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductsLineIncrementComponent } from './products-line-increment/products-line-increment.component';
import { ProductsCambioProdComponent } from './products-cambio-prod/products-cambio-prod.component';

const routesListaProductos: Routes = [
  { path: '', component: ProductsListComponent },
  { path: 'lineIncrement', component: ProductsLineIncrementComponent},
  { path: 'cambioProd', component: ProductsCambioProdComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routesListaProductos)],
  exports: [RouterModule],
})

export class ProductsRoutingModule { }
